import { Controller } from 'stimulus';

export default class extends Controller {
  toggleFaqItem(event) {
    const button = event.currentTarget;
    const itemId = button.getAttribute('aria-controls');
    const content = this.element.querySelector(`#${itemId}`);
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', !isExpanded);
    content.setAttribute('aria-hidden', isExpanded);
    const parent = button.closest('.faq__item');
    parent.classList.toggle('open');
  }
}
